import commonList from './src/index.vue'

commonList.install = function(Vue) {
  Vue.component(commonList.name, commonList)
}

export default commonList
